import {reduxForm} from 'redux-form';
import config from 'config';
import FromComponent from './StreamEditForm';
import {STREAM_ROUTER_ROOT} from '../constants';
import {streamAction} from '../../../../actions/stream/liveStadiumStream';
import {StreamEventStatusType} from '../../../../api/stream/LiveStadiumStreamEvent';
import {validateRedux, validateAsyncRedux} from '../../../../utilites/validate';
import {push} from 'react-router-redux/lib/actions';
let CRUDActions = streamAction;

const validate = (data) => {
  let validationParams = {
    title: {
      presence: {
        message: '^Stream Name is missing'
      }
    },
    startDate: {
      presence: {
        message: '^Please choose an end time'
      },
      datetime: {
        earliest: new Date(),
        message: '^The stream has to be in the future.'
      }
    },
    endDate: {
      presence: {
        message: '^Please choose an end time'
      },
      greaterThan: {key: 'startDate', message: '^Please set the future date'}
    },
    description: {
      presenceContent: {
        message: '^Description is missing'
      }
    },
    // countries: {
    //   presence: {
    //     message: '^Countries is missing'
    //   }
    // }
  };

  return validateRedux(data, validationParams);
};

const asyncValidate = (data) => validateAsyncRedux(data, {
  logo: {
    presence: {message: '^Please upload an image'},
    minImageSizeAsync: config.streamCrop
  }
});

export default reduxForm(
  {
    form: 'stream_edit_form',
    fields: [
      'title',
      'startDate',
      'endDate',
      'logo',
      'status',
      'vip_only',
      'statusType',
      'description',
      // 'countries'
    ],
    returnRejectedSubmitPromise: true,
    model: {},
    asyncValidate,
    asyncBlurFields: ['logo'],
    validate
  },
  ({liveStadiumStream: {model = {}}}) => ({
    model: model,
    disabled: false,//model &&
    //(model.status === StreamEventStatusType.finished || model.status === StreamEventStatusType.active),
    initialValues: model
      ? {
        title: model.title,
        startDate: model.startDate,
        endDate: model.endDate,
        logo: model.logo,
        status: model.status,
        vip_only: model.vip_only,
        statusType: StreamEventStatusType,
        description: model.description,
        // countries: model.countries
      }
      : {}
  }),
  dispatch => ({
    save: (item, data) => dispatch(CRUDActions.save(item, data)),
    publish: (item, data) => dispatch(CRUDActions.publish(item, data)),
    onClose: () => {
      dispatch(push(STREAM_ROUTER_ROOT));
      dispatch(CRUDActions.onCloseEditForm());
    }
  })
)(FromComponent);




// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamEditForm/index.js